import { FC, useRef, useState } from "react";
import { ChatListItem } from "./ChatListItem";
import { useChatStore } from "../../stores/ChatStore";
import { useVirtualizer } from "@tanstack/react-virtual";
import { useIntl } from "react-intl";
import { MerchantLeads, RecentChatHistory } from "../../interfaces/Chat/RecentChatHistory";
import { useSettingsStore } from "../../stores/SettingsStore";
import useUser from "../../hooks/User";
import { ListChatRoom } from "../../interfaces/Chat/Chat";

const ChatListSearch = () => {
  const { selectChatWindow, listFilterChat } = useChatStore();
  const user = useUser()
  const intl = useIntl();
  const { settings } = useSettingsStore()
  const parentRef = useRef<HTMLDivElement>(null);
  const listData = Object.keys(listFilterChat)

  const virtualizer = useVirtualizer({
    count: listData.length,
    getScrollElement: () => parentRef.current,
    estimateSize: (index) => 300,
    overscan: 5, // Tambahkan elemen buffer di atas dan bawah
    enabled: true,
  });

  const items = virtualizer.getVirtualItems();

  const handleClickChatWindow = () => {
    // setSelectChatWindow([
    //   ...selectChatWindow,
    //   { name: clickedChat.chat_name, phone: clickedChat.chat_phone, as: clickedChat.as },
    // ]);
  };

  return (
    <>
      <div
        ref={parentRef}
        style={{
          height: "100%",
          overflowY: "auto",
          position: "relative",
          contain: 'strict',
        }}
      >
        <div
          style={{
            height: virtualizer.getTotalSize(),
            position: "relative",
            width: '100%',
          }}
        >
          {items.map((virtualItem) => {
            const key = listData[virtualItem.index];
            const chatItem = listFilterChat[key]
            const parts = key.split("-");

            return (
              <div
                key={virtualItem.key.toString()}
                data-index={virtualItem.index}
                ref={virtualizer.measureElement}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  transform: `translateY(${virtualItem.start}px)`,
                }}
              >
                {
                  chatItem.chat.id &&
                  <ChatListItem keyChatRoom={`${parts[0]}-${parts[1]}`} type={parts[2]} idChat={parts.slice(3).join("-")} />
                }
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export { ChatListSearch };
